import { MapPin, Clock } from "lucide-react";
import { colors } from "../constants";
import GlassCard from "./GlassCard";
import TeamIcon from "@/components/TeamIcon";

// Tomorrow Match Card - Premium Layout
const TomorrowMatchCard = ({ match, matchNumber = 1 }) => {
  // Extract city from venue
  const getCity = () => {
    const venue = match.venue || "";
    const parts = venue.split(",");
    return parts.length > 1 ? parts[parts.length - 1].trim() : parts[0].trim() || match.team_a;
  };

  return (
    <GlassCard padding="p-[22px]">
      {/* Match Metadata Row - M3 • 📍 City */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2 text-[13px]" style={{ color: colors.textMuted }}>
          <span className="font-medium">M{matchNumber}</span>
          <span>•</span>
          <MapPin className="w-3 h-3" />
          <span>{getCity()}</span>
        </div>
      </div>
      {/* Teams Row - mb-18px */}
      <div className="flex items-center justify-between mb-[18px]">
        <div className="flex items-center gap-3">
          <TeamIcon team={match.team_a} size="sm" />
          <span className="text-sm text-white font-medium">{match.team_a}</span>
        </div>
        <span className="text-xs text-white/30">VS</span>
        <div className="flex items-center gap-3">
          <span className="text-sm text-white font-medium">{match.team_b}</span>
          <TeamIcon team={match.team_b} size="sm" />
        </div>
      </div>
      {/* Start Time & Status */}
      <div className="pt-3 border-t border-white/10">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Clock className="w-3 h-3 text-white/40" />
            <span className="text-xs text-white/50">
              Match starts on{" "}
              {match.date
                ? new Date(match.date).toLocaleDateString("en-IN", {
                    dateStyle: "medium",
                  })
                : match.match_date
                  ? new Date(match.match_date).toLocaleDateString("en-IN", {
                      dateStyle: "medium",
                    })
                  : "TBD"}
            </span>
          </div>
          <span className="text-xs text-white/40">Predictions open 8 hours before match</span>
        </div>
      </div>
    </GlassCard>
  );
};

export default TomorrowMatchCard;
